/** The company providing shipment tracking */
export enum TrackingPlatform {
  EASYPOST = "easypost",
  FEDEX = "fedex",
  TRACK123 = "track123",
  FIRST_MILE = "first_mile",
  EPOST_GLOBAL = "epost_global",
  APC = "apc",
  UPS = "ups",
  LANDMARK_GLOBAL = "landmark_global",
  ETA_EXPRESS = "eta_express",
  DUMMY = "dummy",
  GLOBALE = "globale",
  NZ_POST = "nz_post",
  WWEX = "wwex",
  DHL_ECS = "dhl_ecs",
  SENDCLOUD = "sendcloud",
  SENDCLOUD_EU = "sendcloud_eu",
  WEGROW = "wegrow",
  USPS = "usps",
  UNIUNI = "uniuni",
  STALLION_EXPRESS = "stallion_express",
  ECOM_EXPRESS = "ecom_express",
  AMAZON_BUY_SHIPPING = "amazon_buy_shipping",
  CHITCHATS = "chitchats",
}
